import accessibleAutocomplete from 'accessible-autocomplete';

function fetchSuggestions (query: string, populateResults: (s: string[]) => void): void {
    const endpoint = document.getElementById('header-search-form')?.dataset.suggest || '';
    const ajaxRequest = new XMLHttpRequest();
    ajaxRequest.open('GET', endpoint + '?tx_solr[queryString]=' + query);
    ajaxRequest.send();
    ajaxRequest.onreadystatechange = function () {
        if (ajaxRequest.readyState === 4 && ajaxRequest.status === 200) {
            const responseText = ajaxRequest.responseText;
            let response = null;
            try {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                response = JSON.parse(responseText);
            } catch (error) {
                return;
            }
            /* eslint-disable @typescript-eslint/no-unsafe-member-access */
            if (response instanceof Object && !response.status && response.suggestions) {
                const suggestionArray = [];
                for (const suggestion in response.suggestions) {
                    suggestionArray.push(suggestion);
                }
                populateResults(suggestionArray);
            }
        }
    };
}

function autocompleteByType (searchType: string): void {
    const autocompleteContainer = document.getElementById(searchType + '-autocomplete-container');
    if (autocompleteContainer) {
        // Get previous query term and input name from document
        const searchInputSolr = (document.getElementById(searchType + '-input') as HTMLInputElement);
        const options: { [key: string]: unknown } = {
            element: autocompleteContainer,
            id: searchType + '-input',
            defaultValue: searchInputSolr.value,
            name: searchInputSolr.name,
            showNoOptionsFound: false,
            source: fetchSuggestions,
            onConfirm: (confirmed: string) => {
                if (confirmed && confirmed.trim()) {
                    (document.getElementById(searchType + '-input') as HTMLInputElement).value = confirmed.trim();
                    (document.getElementById(searchType + '-search-form') as HTMLFormElement).submit();
                }
            },
            confirmOnBlur: false,
            tAssistiveHint: () => '', // too annoying: 'Nutze die Pfeiltasten und die Eingabetaste zur Auswahl. Am Touch-Screen verwende Berührungen und Wischgesten.'
            tStatusNoResults: () => '', // too annoying: 'Keine Suchvorschläge'
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            tStatusSelectedOption: (selectedOption: string, length: number, index: number) => '' // too annoying: `${selectedOption} ${index + 1} von ${length} ist hervorgehoben.`
        };

        // Remove original input field before autocomplete init, as that adds its own
        searchInputSolr.remove();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        accessibleAutocomplete(options);
        const searchInputAutocomplete = (document.getElementById(searchType + '-input') as HTMLInputElement);
        searchInputAutocomplete.type = 'search';
    }
}

function autocomplete (): void {
    autocompleteByType('header');
    autocompleteByType('results');
}

export default autocomplete;
